// Beta-shaped segments. condition is the nested AND/OR tree the real API uses.
const rule = (attribute_id, operator, value) => ({ type: 'attribute', attribute_id, operator, value });
const group = (rules, op = 'AND') => ({ criteria_operator: op, criteria_id_1: rules });

export const segments = [
  { segment_id: 2000, name: 'Pet DNA Kit owners', condition_operator: 'AND',
    condition: [ { criteria_operator: 'AND', criteria_id_1: [ { type: 'product', operator: 'INCLUSIVE', value: ['Pet DNA Kit'] } ] } ] },
  { segment_id: 2001, name: 'Allergies = Yes', condition_operator: 'AND',
    condition: [ group([ rule(501, 'EQUAL', ['Yes']) ]) ] },
  { segment_id: 2002, name: 'Allergies = No', condition_operator: 'AND',
    condition: [ group([ rule(501, 'EQUAL', ['No']) ]) ] },
  { segment_id: 2003, name: 'Diet = Premium', condition_operator: 'AND',
    condition: [ group([ rule(502, 'EQUAL', ['Premium']) ]) ] },
  { segment_id: 2004, name: 'Severe = Yes', condition_operator: 'AND',
    condition: [ group([ rule(503, 'EQUAL', ['Yes']) ]) ] },
  // multi-trigger: references attribute 501 (from touchpoint 101) AND 502 (from touchpoint 102)
  { segment_id: 2005, name: 'Allergies = Yes AND Diet = Premium', condition_operator: 'AND',
    condition: [ group([ rule(501, 'EQUAL', ['Yes']), rule(502, 'EQUAL', ['Premium']) ]) ] },
];

export const segmentById = (id) => segments.find((s) => s.segment_id === id) || null;

export function segmentAttributeRefs(segment) {
  if (!segment || !Array.isArray(segment.condition)) return [];
  const refs = [];
  segment.condition.forEach((grp) => {
    Object.keys(grp).forEach((key) => {
      if (!Array.isArray(grp[key])) return;
      grp[key].forEach((r) => {
        if (r.type === 'attribute' && r.attribute_id != null) refs.push({ attribute_id: String(r.attribute_id), value: (r.value || [])[0] });
      });
    });
  });
  return refs;
}

// Human-readable criteria chips for the segment bar (no segment name used).
// Returns an array of strings like ["Allergies = Yes", "Diet = Premium"].
export function segmentChips(segment, attributeById) {
  if (!segment) return [];
  const OPS = { EQUAL: '=', GREATER_THAN: '>', LESS_THAN: '<', INCLUSIVE: 'is', EXCLUSIVE: 'is not' };
  const out = [];
  (segment.condition || []).forEach((grp) => {
    Object.keys(grp).forEach((key) => {
      if (!Array.isArray(grp[key])) return;
      grp[key].forEach((r) => {
        if (r.type === 'product') out.push(`Product incl. ${(r.value || []).join(', ')}`);
        else if (r.type === 'attribute') {
          const a = attributeById(r.attribute_id);
          const name = a ? a.name : `Attribute ${r.attribute_id}`;
          const op = OPS[r.operator] || r.operator;
          const vals = r.value || [];
          // collapse multi-value INCLUSIVE/EXCLUSIVE arrays to the longest value (ties keep the first)
          let val;
          if (vals.length > 1 && (r.operator === 'INCLUSIVE' || r.operator === 'EXCLUSIVE')) {
            val = vals.reduce((best, cur) => (best.length >= cur.length ? best : cur));
          } else {
            val = vals.join(', ');
          }
          out.push(`${name} ${op} ${val}`);
        }
      });
    });
  });
  return out;
}

// Union of a segment's attribute refs with all its ancestors' (via parent_segment_id).
// NOTE: parent inheritance AND/OR semantics are unconfirmed against the backend;
// this permissive union is used only to link a touchpoint response to a journey.
export function resolveSegmentRefs(segment, segById) {
  const out = [];
  const seen = new Set();
  let cur = segment;
  while (cur && !seen.has(cur.segment_id)) {
    seen.add(cur.segment_id);
    segmentAttributeRefs(cur).forEach((r) => out.push(r));
    cur = cur.parent_segment_id != null && segById ? segById.get(cur.parent_segment_id) : null;
  }
  return out;
}
